import { Box } from "@chakra-ui/react";

interface TimeColumnProps {
  timeColumnWidth: number;
  slotHeight: number;
  hours: number[];
}

export default function TimeColumn({ timeColumnWidth, slotHeight, hours }: TimeColumnProps) {
  const formatHour = (hour: number) => {
    if (hour === 0) return "12 AM";
    if (hour === 12) return "12 PM";
    if (hour < 12) return `${hour} AM`;
    return `${hour - 12} PM`;
  };

  return (
    <Box
      width={`${timeColumnWidth}px`}
      position="relative"
      borderRightWidth="1px" borderRightColor="gray.200"
      bg="gray.50"
      height={`${24 * slotHeight}px`}
    >
      {/* Hour labels */}
      {hours.slice(1).map((hour) => (
        <Box key={hour} position="relative">
          <Box
            position="absolute"
            top={`${hour * slotHeight - 8}px`}
            right={2}
            fontSize="xs"
            color="gray.500"
            textAlign="right"
            mr={2}
          >
            <strong>{formatHour(hour)}</strong>
          </Box>
          {/* Hour line extending into calendar */}
          <Box
            position="absolute"
            top={`${hour * slotHeight}px`}
            right={0}
            width="10px"
            height="1px"
            bg="gray.300"
          />
        </Box>
      ))}
    </Box>
  );
}
